<template>
  <div>
    <announcement ref="announcement" v-if="[1834].includes($store.state.shop.id) && clerk && clerk.randomOrderSwitch != null && !clerk.randomOrderSwitch "/>
    <announcement ref="announcement" v-else-if="![1834].includes($store.state.shop.id)"/>
    <balanceWithdraw v-show="![180].includes($store.state.shop.id)" :showTitle="true"></balanceWithdraw>
<!--    <van-notice-bar v-if="[1,1834].includes($store.state.shop.id) && clerk &&!clerk.randomOrderSwitch && $refs.announcement.announcement"-->
<!--                    left-icon="volume-o"-->
<!--                    text="点击查看公告"-->
<!--                    @click="$refs.announcement.showDialog"/>-->
    <van-cell-group v-if="hasRole('clerk')">

      <div slot="title" style="position: relative;">
        <div class="flex align-center justify-between">
          <span>店员</span>

          <div v-if="clerk != null" class="flex align-center">
            <template v-if="$hasFeature('auto_online')">
              <span v-if="clerkIsAutoOnline" style="color:var(--primary-color);">自动在线</span>
              <span v-else-if="!clerkIsAutoOnline" class="text-gray">手动在线</span>
              <van-switch v-model="clerkIsAutoOnline" active-color="var(--primary-color)"
                          class="margin-left-sm margin-right-sm"
                          inactive-color="var(--grey)"
                          size="24" @input="(input)=>updateClerkIsAutoOnline(input)"/>
            </template>
            <span v-if="clerk.status == 1"
                  style="color:var(--primary-color);">{{ $store.state.shop.id === 1508 ? '我可以秒接单' : '在线' }}</span>
            <span v-else-if="clerk.status == 2" class="text-gray">离线</span>
            <van-switch :active-value="1" :inactive-value="2" :loading="updateClerkStatusLoading"
                        :value="clerk.status"
                        active-color="var(--primary-color)" class="margin-left-sm"
                        inactive-color="var(--grey)"
                        size="24"
                        @input="(input)=>updateStatus(input,'clerk')"/>

          </div>
        </div>
        <div class="flex justify-end align-center margin-top-sm">
          <div v-if="$ClerkPermission.modifiableClerkAttr.includes('randomOrderSwitch')"
               class="flex align-center">
                      <span :style="{color: clerk && clerk.randomOrderSwitch?'var(--primary-color)':'gray'}"
                            class="flex align-center">
                        <question-mark class="margin-right-xs" msg="在线且随机单开启时，才会接收到随机单通知"/>
                        随机单
                      </span>
            <van-switch :value="clerk && clerk.randomOrderSwitch" active-color="var(--primary-color)"
                        class="margin-left-sm" inactive-color="var(--grey)"
                        size="24" @input="(input)=>updateRandomOrderSwitch(input)"/>

          </div>
          <div v-if="$hasFeature('clerk_recommend_on')" class="flex align-center margin-left-sm">
                  <span :style="{color: clerk && clerk.isRecommendOn?'var(--primary-color)':'gray'}">
                    <question-mark class="margin-right-xs"
                                   msg="在线状态才可开启，离线会自动关闭，开启满5个小时会自动关闭，开启期间有超时单或投诉单会被隐藏并关闭上推荐状态"/>
                    我要上推荐
                  </span>
            <van-switch :active-value="true" :inactive-value="false" :loading="updateClerkRecommendOnLoading"
                        :value="clerk.isRecommendOn"
                        active-color="var(--primary-color)" class="margin-left-sm"
                        inactive-color="var(--grey)"
                        size="24"
                        @input="(input)=>updateRecommendOn(input)"/>
          </div>
        </div>
      </div>
      <!--      <div v-if="itemSwitchList.length > 0" class="item-switch">-->
      <!--        <van-row type="flex">-->
      <!--          <van-col v-for="(switchItem, index) of itemSwitchList" :key="index" class="switch-wrap" span="6"-->
      <!--                   style="padding: 2px 0">-->
      <!--            <van-switch :value="clerkItemSwitchIds.indexOf(switchItem.id) != -1" active-color="var(&#45;&#45;primary-color)"-->
      <!--                        inactive-color="var(&#45;&#45;grey)" size="18" @change="updateItemSwitch(switchItem.id)"/>-->
      <!--            <div class="item-name">{{ switchItem.name }}</div>-->
      <!--          </van-col>-->
      <!--        </van-row>-->
      <!--      </div>-->

      <div style="margin-bottom: 10px">
        <div class="switch-title" @click="specifyShow = !specifyShow">
          <div class="title">{{ $store.state.shop.id === 1508 ? '个人主页服务技能开关' : '指定单开关' }}</div>
          <div class="title-right">
            <span>{{ !specifyShow ? '展开' : '收取' }}</span>
            <img src="/static/images/default/down1.png" :style="!specifyShow? 'transform:rotate(180deg)' : ''">
          </div>
        </div>
        <div v-if="specifyShow" class="switch-body">
          <div v-for="(item1,index1) of specifySwitch" :key="index1">
            <div class="title">{{ item1.name }}：</div>
            <div class="switch-box">
              <div class="switch" v-for="(item2,index2) of item1.list" :key="index2">
                <van-switch :value="clerkItemSwitchIds.indexOf(item2.id) != -1" active-color="var(--primary-color)"
                            inactive-color="var(--grey)" size="17" @change="updateItemSwitch(item2.id)"/>
                <span class="switch-name text-ellipsis">{{ item2.name }}</span>
              </div>
            </div>
          </div>
        </div>

        <div v-if="randomSwitch.length>0" class="switch-title" @click="randomShow = !randomShow">
          <div class="title">{{ $store.state.shop.id === 1508 ? '接收呼叫大神技能开关' : '随机单开关' }}</div>
          <div class="title-right">
            <span>{{ !randomShow ? '展开' : '收取' }}</span>
            <img src="/static/images/default/down1.png" :style="!randomShow? 'transform:rotate(180deg)' : ''">
          </div>
        </div>
        <div v-if="randomShow" class="switch-body">
          <div v-for="(item1,index1) of randomSwitch" :key="index1">
            <div class="title">{{ item1.name }}：</div>
            <div class="switch-box">
              <div class="switch" v-for="(item2,index2) of item1.list" :key="index2">
                <van-switch :value="clerkItemSwitchIds.indexOf(item2.id) != -1" active-color="var(--primary-color)"
                            inactive-color="var(--grey)" size="17" @change="updateItemSwitch(item2.id)"/>
                <span class="switch-name text-ellipsis">{{ item2.name }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>


      <!--            <div class="specifyTitle" @click="specifyShow = !specifyShow" v-if="specifySwitch.length != 0">-->
      <!--                <div>-->
      <!--                    指定单-->
      <!--                </div>-->
      <!--                <img src="/static/images/1508/down.png" class="down"-->
      <!--                     :style="!specifyShow? 'transform:rotate(180deg)' : ''">-->
      <!--            </div>-->
      <!--            <div class="specifyFold" :style="!specifyShow? 'max-height:9999px' : 'max-height:0px'">-->
      <!--                <div v-for="(item, index) in specifySwitch" :key="index" class="switchItem">-->
      <!--                    <van-switch :value="clerkItemSwitchIds.indexOf(item.id) != -1" active-color="var(&#45;&#45;primary-color)"-->
      <!--                                inactive-color="var(&#45;&#45;grey)" size="18" @change="updateItemSwitch(item.id)"/>-->
      <!--                    <div class="item-name">{{ item.name }}</div>-->
      <!--                </div>-->
      <!--            </div>-->
      <!--            <div class="randomTitle" @click="randomShow = !randomShow" v-if="randomSwitch.length != 0">-->
      <!--                <div>-->
      <!--                    随机单-->
      <!--                </div>-->
      <!--                <img src="/static/images/1508/down.png" class="down"-->
      <!--                     :style="randomShow? 'transform:rotate(180deg)' : ''">-->
      <!--            </div>-->
      <!--            <div class="randomFold" :style="randomShow? 'max-height:9999px' : 'max-height:0px'">-->
      <!--                <div v-for="(item, index) in randomSwitch" :key="index" class="switchItem">-->
      <!--                    <van-switch :value="clerkItemSwitchIds.indexOf(item.id) != -1" active-color="var(&#45;&#45;primary-color)"-->
      <!--                                inactive-color="var(&#45;&#45;grey)" size="18" @change="updateItemSwitch(item.id)"/>-->
      <!--                    <div class="item-name">{{ item.name }}</div>-->

      <!--                </div>-->
      <!--            </div>-->

      <van-row class="grid">
        <van-col v-if="$ClerkAccess.includes('manual')" span="8">
          <router-link class="item van-hairline--bottom van-hairline--right" to="/article/list?type=2">
            <div class="icon-box">
              <i class="iconfont icon-gongzuotai-gongzi icon-a"></i>
              <i class="iconfont icon-gongzuotai-dianyuanshouce-2 icon-b"></i>
            </div>
            <div class="text">店员手册</div>
          </router-link>
        </van-col>
        <van-col v-if="$hasFeature('clerk_circle') && $ClerkAccess.includes('clerk_circle')" span="8">
          <router-link class="item van-hairline--bottom van-hairline--right" to="/clerk/circle">
            <div class="icon-box">
              <i class="iconfont  icon-a-163-dianyuanquanzi icon-a"></i>
              <i class="iconfont icon-a-163-dianyuanquanzi-2 icon-b"></i>
            </div>
            <div class="text">店员圈子</div>
          </router-link>
        </van-col>
        <van-col v-if="$ClerkAccess.includes('order')" span="8">
          <router-link class="item van-hairline--bottom van-hairline--right" to="/clerk/order/list">
            <div class="icon-box">
              <i class="iconfont icon-gongzuotai-waibudingdan icon-a"></i>
              <i class="iconfont icon-gongzuotai-dingdan-2 icon-b"></i>
            </div>
            <div class="text">订单</div>
          </router-link>
        </van-col>
        <van-col v-if="$hasFeature('dispatch_order') && $ClerkAccess.includes('dispatchOrder')" span="8">
          <router-link class="item van-hairline--bottom van-hairline--right" to="/clerk/dispatchOrder/list">
            <div class="icon-box">
              <i class="iconfont icon-gongzuotai-paidan icon-a"></i>
              <i class="iconfont icon-gongzuotai-paidan-2 icon-b"></i>
            </div>
            <div class="text">派单</div>
          </router-link>
        </van-col>
        <van-col v-if="$hasFeature('dispatch_order') && $ClerkAccess.includes('uploadDispatchOrder')" span="8">
          <router-link class="item van-hairline--bottom van-hairline--right" to="/clerk/dispatchOrder/uploadDispatch">
            <div class="icon-box">
              <i class="iconfont icon-gongzuotai-shangchuanpaidan icon-a"></i>
              <i class="iconfont icon-gongzuotai-shangchuanpaidan-2 icon-b"></i>
            </div>
            <div class="text">上传派单</div>
          </router-link>
        </van-col>
        <van-col
            v-if="$hasFeature('dispatch_order') && $ClerkAccess.includes('uploadOutDispatchOrder') && dispatchOrderPermission.includes('upload_out_dispatch_order')"
            span="8">
          <router-link class="item van-hairline--bottom van-hairline--right"
                       to="/clerk/dispatchOrder/uploadOutDispatch">
            <div class="icon-box">
              <i class="iconfont icon-gongzuotai-shangchuanpaidan icon-a"></i>
              <i class="iconfont icon-gongzuotai-shangchuanpaidan-2 icon-b"></i>
            </div>
            <div class="text">上传外派订单</div>
          </router-link>
        </van-col>
        <van-col v-if="$ClerkAccess.includes('random')" span="8">
          <router-link class="item van-hairline--bottom van-hairline--right" to="/clerk/random">
            <div class="icon-box">
              <i class="iconfont icon-gongzuotai-qiangdandating icon-a"></i>
              <i class="iconfont icon-gongzuotai-qiangdandating-2 icon-b"></i>
            </div>
            <div class="text">抢单大厅</div>
          </router-link>
        </van-col>
        <van-col v-if="$hasFeature('out_order') && $ClerkAccess.includes('out-order')" span="8">
          <router-link class="item van-hairline--bottom van-hairline--right" to="/clerk/order/out-order-list">
            <div class="icon-box">
              <i class="iconfont icon-gongzuotai-waibudingdan icon-a"></i>
              <i class="iconfont icon-gongzuotai-waibudingdan-2 icon-b"></i>
            </div>
            <div class="text">外部订单</div>
          </router-link>
        </van-col>
        <van-col v-if="$hasFeature('first_order') && $ClerkAccess.includes('first-order')" span="8">
          <router-link class="item van-hairline--bottom van-hairline--right" to="/clerk/out_first_order/list">
            <div class="icon-box">
              <i class="iconfont icon-gongzuotai-shoudantiyan icon-a"></i>
              <i class="iconfont icon-gongzuotai-shoudantiyan-2 icon-b"></i>
            </div>
            <div class="text">首单体验</div>
          </router-link>
        </van-col>
        <van-col v-if="$ClerkAccess.includes('wages') && clerk.groupId!=3590" span="8">
          <router-link class="item van-hairline--bottom van-hairline--right" to="/clerk/wages">
            <div class="icon-box">
              <i class="iconfont icon-gongzuotai-gongzi icon-a"></i>
              <i class="iconfont icon-gongzuotai-gongzi-2 icon-b"></i>
            </div>
            <div class="text">工资</div>
          </router-link>
        </van-col>
        <van-col
            v-if="($hasFeature('clerk_ranking') || $store.state.shop.version === 'combination') && $ClerkAccess.includes('ranking-list')"
            span="8">
          <router-link class="item van-hairline--bottom van-hairline--right" to="/clerk/ranking-list">
            <div class="icon-box">
              <i class="iconfont icon-gongzuotai-wodepaiming icon-a"></i>
              <i class="iconfont icon-gongzuotai-wodepaiming-2 icon-b"></i>
            </div>
            <div class="text">我的排名</div>
          </router-link>
        </van-col>
        <van-col v-if="$ClerkAccess.includes('info')" span="8">
          <router-link class="item van-hairline--bottom van-hairline--right" to="/clerk/info">
            <div class="icon-box">
              <i class="iconfont icon-gongzuotai-wodeziliao icon-a"></i>
              <i class="iconfont icon-gongzuotai-wodeziliao-2 icon-b"></i>
            </div>
            <div class="text">我的资料</div>
          </router-link>
        </van-col>
        <!-- 开通了2362自定义功能 -->
        <van-col v-if="$hasFeature('custom_2362')" span="8">
          <router-link class="item van-hairline--bottom van-hairline--right" to="/clerk/clerkCategory">
            <div class="icon-box">
              <i class="iconfont icon-gongzuotai-jinengshenqing icon-a"></i>
              <i class="iconfont icon-gongzuotai-jinengshenqing-2 icon-b"></i>
            </div>
            <div class="text">我的技能</div>
          </router-link>
        </van-col>
        <van-col v-if="$ClerkAccess.includes('grade')" span="8">
          <router-link class="item van-hairline--bottom van-hairline--right" to="/clerk/grade">
            <div class="icon-box">
              <i class="iconfont icon-gongzuotai-wodedengji icon-a"></i>
              <i class="iconfont icon-gongzuotai-wodedengji-2 icon-b"></i>
            </div>
            <div class="text">我的等级</div>
          </router-link>
        </van-col>
        <van-col v-if="$ClerkAccess.includes('reward-log')" span="8">
          <router-link class="item van-hairline--bottom van-hairline--right" to="/clerk/reward-log">
            <div class="icon-box">
              <i class="iconfont icon-gongzuotai-dashangdongtai icon-a"></i>
              <i class="iconfont icon-gongzuotai-dashangdongtai-2 icon-b"></i>
            </div>
            <div class="text">打赏动态</div>
          </router-link>
        </van-col>
        <!--    开放动态广场    -->
        <van-col v-if="$hasFeature('post_list') && $ClerkAccess.includes('post-list')" span="8">
          <router-link class="item van-hairline--bottom van-hairline--right" to="/clerk/post/list">
            <div class="icon-box">
              <i class="iconfont icon-gongzuotai-fabudongtai icon-a"></i>
              <i class="iconfont icon-gongzuotai-fabudongtai-2 icon-b"></i>
            </div>
            <div class="text">发布动态</div>
          </router-link>
        </van-col>
        <van-col v-if="$hasFeature('auto_online') && $ClerkAccess.includes('auto-online')" span="8">
          <router-link class="item van-hairline--bottom van-hairline--right" to="/clerk/auto/online">
            <div class="icon-box">
              <i class="iconfont icon-gongzuotai-zidongzaixian icon-a"></i>
              <i class="iconfont icon-gongzuotai-zidongzaixian-2 icon-b"></i>
            </div>
            <div class="text">自动在线</div>
          </router-link>
        </van-col>
        <van-col v-if="$ClerkAccess.includes('clerk-houtai')" span="8">
          <router-link class="item van-hairline--bottom van-hairline--right" to="/clerk/clerk-houtai">
            <div class="icon-box">
              <i class="iconfont icon-gongzuotai-dianyuanzhongxin icon-a"></i>
              <i class="iconfont icon-gongzuotai-dianyuanzhongxin-2 icon-b"></i>
            </div>
            <div class="text">店员中心</div>
          </router-link>
        </van-col>
        <van-col v-if="$hasFeature('gift_wall') && $ClerkAccess.includes('gift')" span="8">
          <router-link class="item van-hairline--bottom van-hairline--right" to="/clerk/gift">
            <div class="icon-box">
              <i class="iconfont icon-gongzuotai-wodeliwu icon-a"></i>
              <i class="iconfont icon-gongzuotai-wodeliwu-2 icon-b"></i>
            </div>
            <div class="text">我的礼物</div>
          </router-link>
        </van-col>
        <van-col span="8" v-if="$ClerkAccess.includes('my-performance')">
          <router-link
              class="item van-hairline--bottom van-hairline--right" to="/clerk/performance">
            <div class="icon-box">
              <i class="iconfont icon-gongzuotai-wodeyeji icon-a"></i>
              <i class="iconfont icon-gongzuotai-wodeyeji-2 icon-b"></i>
            </div>
            <div class="text">我的业绩</div>
          </router-link>
        </van-col>
        <van-col span="8" v-if="$hasFeature('clerk_item_price') && $ClerkAccess.includes('item-price')">
          <router-link
              class="item van-hairline--bottom van-hairline--right" to="/clerk/item-price">
            <div class="icon-box">
              <i class="iconfont icon-gongzuotai-fuwujiage icon-a"></i>
              <i class="iconfont icon-gongzuotai-fuwujiage-2 icon-b"></i>
            </div>
            <div class="text">服务价格</div>
          </router-link>
        </van-col>
        <van-col span="8" v-if="$hasFeature('chat') && $ClerkAccess.includes('chat') && $store.state.shopSetting.chat.isUsed">
          <router-link
              class="item van-hairline--bottom van-hairline--right" to="/clerk/chat/roomListAndOnline">
            <div class="icon-box">
              <i class="iconfont icon-gongzuotai-liaotian icon-a"></i>
              <i class="iconfont icon-gongzuotai-liaotian-2 icon-b"></i>
            </div>
            <div class="text">聊天消息</div>
          </router-link>
        </van-col>
<!--        <van-col span="8" v-if="$hasFeature('chat') && $ClerkAccess.includes('chat') && [1,141,2184].includes($store.state.shop.id)">-->
<!--          <router-link-->
<!--              class="item van-hairline&#45;&#45;bottom van-hairline&#45;&#45;right" to="/clerk/chat/onlineList">-->
<!--            <div class="icon-box">-->
<!--              <i class="iconfont icon-gongzuotai-liaotian icon-a"></i>-->
<!--              <i class="iconfont icon-gongzuotai-liaotian-2 icon-b"></i>-->
<!--            </div>-->
<!--            <div class="text">在线客户</div>-->
<!--          </router-link>-->
<!--        </van-col>-->
        <van-col
            v-if="$hasFeature('clerk_category_apply') && $ClerkAccess.includes('clerk_category_apply') && clerkJoinCategoryApply"
            span="8">
          <!-- 勾选了加入技能需要申请 -->
          <router-link class="item van-hairline--bottom van-hairline--right" to="/clerk/clerk-category-apply-list">
            <div class="icon-box">
              <i class="iconfont icon-gongzuotai-jinengshenqing icon-a"></i>
              <i class="iconfont icon-gongzuotai-jinengshenqing-2 icon-b"></i>
            </div>
            <div class="text">技能申请</div>
          </router-link>
        </van-col>
        <van-col
            v-if="$hasFeature('clerk_category_apply') && ($store.state.shop.id == 154 || $store.state.shop.id == 1)"
            span="8">
          <!-- 勾选了技能等级页面权限 -->
          <router-link class="item van-hairline--bottom van-hairline--right" to="/clerk/clerk-category-grade">
            <div class="icon-box">
              <i class="iconfont icon-gongzuotai-jinengdengji icon-a"></i>
              <i class="iconfont icon-gongzuotai-jinengdengji-2 icon-b"></i>
            </div>
            <div class="text">技能等级</div>
          </router-link>
        </van-col>
        <van-col span="8" v-if="$hasFeature('clerk_point')">
          <router-link class="item van-hairline--bottom van-hairline--right" to="/clerk/sign-in">
            <div class="icon-box">
              <i class="iconfont icon-gongzuotai-qiandao icon-a"></i>
              <i class="iconfont icon-gongzuotai-qiandao-2 icon-b"></i>
            </div>
            <div class="text">签到</div>
          </router-link>
        </van-col>
        <van-col span="8" v-if="$hasFeature('clerk_pk')">
          <router-link class="item van-hairline--bottom van-hairline--right" to="/clerk/clerk-pk">
            <div class="icon-box">
              <i class="iconfont icon-gongzuotai-dianyuanPK icon-a"></i>
              <i class="iconfont icon-gongzuotai-dianyuanPK-2 icon-b"></i>
            </div>
            <div class="text">店员PK</div>
          </router-link>
        </van-col>
        <van-col span="8" v-if="$hasFeature('clerk_quity')">
          <!-- 勾选了技能等级页面权限 -->
          <router-link class="item van-hairline--bottom van-hairline--right" to="/fwshop">
            <div class="icon-box">
              <i class="iconfont icon-gongzuotai-wodeliwu icon-a"></i>
              <i class="iconfont icon-gongzuotai-wodeliwu-2 icon-b"></i>
            </div>
            <div class="text">特权商城</div>
          </router-link>
        </van-col>
        <van-col span="8" v-if="$hasFeature('clerk_quity') && $ClerkAccess.includes('clerk-order')">
          <!-- 勾选了权益订单页面权限 -->
          <router-link class="item van-hairline--bottom van-hairline--right" to="/clerk/order/clerk-order-list">
            <div class="icon-box">
              <i class="iconfont icon-gongzuotai-waibudingdan icon-a"></i>
              <i class="iconfont icon-gongzuotai-dingdan-2 icon-b"></i>
            </div>
            <div class="text">权益订单</div>
          </router-link>
        </van-col>
      </van-row>
    </van-cell-group>

    <van-cell-group v-if="hasRole('kf')" title="客服">
      <div slot="title" style="position: relative;">客服
        <div v-if="kf != null" class="clerk-status">
          <span v-if="kf.status == 1" style="color: var(--primary-color)">在线</span>
          <span v-else-if="kf.status == 2" class="text-gray">离线</span>
          <van-switch :active-value="1" :inactive-value="2" :loading="updateKfStatusLoading"
                      :value="kf.status"
                      active-color="var(--primary-color)" class="margin-left-sm" inactive-color="var(--grey)"
                      size="24"
                      @input="(input)=>{updateStatus(input,'kf')}"/>
        </div>
      </div>
      <van-row class="grid">
        <van-col v-if="$KfAccess.includes('manual')" span="8">
          <router-link class="item van-hairline--bottom van-hairline--right" to="/article/list?type=3">
            <div class="icon-box">
              <i class="iconfont icon-gongzuotai-gongzi icon-a"></i>
              <i class="iconfont icon-gongzuotai-dianyuanshouce-2 icon-b"></i>
            </div>
            <div class="text">客服手册</div>
          </router-link>
        </van-col>
        <van-col v-if="$KfAccess.includes('order')" span="8">
          <router-link class="item van-hairline--bottom van-hairline--right" to="/kf/order/list">
            <div class="icon-box">
              <i class="iconfont icon-gongzuotai-waibudingdan icon-a"></i>
              <i class="iconfont icon-gongzuotai-dingdan-2 icon-b"></i>
            </div>
            <div class="text">订单</div>
          </router-link>
        </van-col>
        <van-col v-if="$hasFeature('order_rate') && $KfAccess.includes('order-rate')" span="8">
          <router-link class="item van-hairline--bottom van-hairline--right" to="/kf/order/rate-list">
            <div class="icon-box">
              <i class="iconfont icon-gongzuotai-dingdanpingjia icon-a"></i>
              <i class="iconfont icon-gongzuotai-dingdanpingjia-2 icon-b"></i>
            </div>
            <div class="text">订单评价</div>
          </router-link>
        </van-col>
        <van-col v-if="$hasFeature('order_complaint') && $KfAccess.includes('order-complain')" span="8">
          <router-link class="item van-hairline--bottom van-hairline--right" to="/kf/order/complain-list">
            <div class="icon-box">
              <i class="iconfont icon-gongzuotai-dingdantousu icon-a"></i>
              <i class="iconfont icon-gongzuotai-dingdantousu-2 icon-b"></i>
            </div>
            <div class="text">订单投诉</div>
          </router-link>
        </van-col>
        <van-col v-if="$hasFeature('kf_wage_statistics') && $KfAccess.includes('wages')" span="8">
          <router-link class="item van-hairline--bottom van-hairline--right" to="/kf/wages">
            <div class="icon-box">
              <i class="iconfont icon-gongzuotai-gongzi icon-a"></i>
              <i class="iconfont icon-gongzuotai-gongzi-2 icon-b"></i>
            </div>
            <div class="text">工资</div>
          </router-link>
        </van-col>
        <van-col v-if="$hasFeature('order_entry_list') && $KfAccess.includes('order-entry')" span="8">
          <router-link class="item van-hairline--bottom van-hairline--right" to="/kf/order-entry">
            <div class="icon-box">
              <i class="iconfont icon-gongzuotai-dingdanluru icon-a"></i>
              <i class="iconfont icon-gongzuotai-dingdanluru-2 icon-b"></i>
            </div>
            <div class="text">订单录入</div>
          </router-link>
        </van-col>
        <van-col v-if="$hasFeature('first_order') && $KfAccess.includes('first-order')" span="8">
          <router-link class="item van-hairline--bottom van-hairline--right" to="/kf/first-order">
            <div class="icon-box">
              <i class="iconfont icon-gongzuotai-shoudantiyan icon-a"></i>
              <i class="iconfont icon-gongzuotai-shoudantiyan-2 icon-b"></i>
            </div>
            <div class="text">首单体验</div>
          </router-link>
        </van-col>
        <van-col v-if="$KfAccess.includes('continued-apply') && $hasFeature('order_continued_apply')" span="8">
          <router-link class="item van-hairline--bottom van-hairline--right" to="/kf/order/continued-apply">
            <div class="icon-box">
              <i class="iconfont icon-gongzuotai-xudanshenhe icon-a"></i>
              <i class="iconfont icon-gongzuotai-xudanshenhe-2 icon-b"></i>
            </div>
            <div class="text">续单审核</div>
          </router-link>
        </van-col>
        <van-col v-if="$hasFeature('out_order') && $KfAccess.includes('out-order')" span="8">
          <router-link class="item van-hairline--bottom van-hairline--right" to="/kf/order/out-order-list">
            <div class="icon-box">
              <i class="iconfont icon-gongzuotai-waibudingdan icon-a"></i>
              <i class="iconfont icon-gongzuotai-waibudingdan-2 icon-b"></i>
            </div>
            <div class="text">外部订单</div>
          </router-link>
        </van-col>
        <van-col v-if="$KfAccess.includes('user-manage')" span="8">
          <router-link class="item van-hairline--bottom van-hairline--right" to="/kf/user/user-list">
            <div class="icon-box">
              <i class="iconfont icon-gongzuotai-yonghuguanli icon-a"></i>
              <i class="iconfont icon-gongzuotai-yonghuguanli-2 icon-b"></i>
            </div>
            <div class="text">用户管理</div>
          </router-link>
        </van-col>
        <van-col span="8" v-if="$hasFeature('clerk_quity') && $KfAccess.includes('clerk-order')">
          <!-- 勾选了权益订单页面权限 -->
          <router-link class="item van-hairline--bottom van-hairline--right" to="/kf/order/clerk-order-list">
            <div class="icon-box">
              <i class="iconfont icon-gongzuotai-waibudingdan icon-a"></i>
              <i class="iconfont icon-gongzuotai-dingdan-2 icon-b"></i>
            </div>
            <div class="text">权益订单</div>
          </router-link>
        </van-col>
      </van-row>
    </van-cell-group>

    <van-cell-group v-if="$hasFeature('guild') && hasRole('guilder')" title="会长">
      <div slot="title" style="position: relative;">会长
      </div>
      <van-row class="grid">
        <van-col v-if="$GuilderAccess.includes('clerk-apply')" span="8">
          <router-link class="item van-hairline--bottom van-hairline--right" to="/guilder/clerk-apply-list">
            <div class="icon-box">
              <i class="iconfont icon-gongzuotai-xindianyuanshenqing icon-a"></i>
              <i class="iconfont icon-gongzuotai-xindianyuanshenqing-2 icon-b"></i>
            </div>
            <div class="text">新店员申请</div>
          </router-link>
        </van-col>
        <van-col v-if="$GuilderAccess.includes('clerk-performance')" span="8">
          <router-link class="item van-hairline--bottom van-hairline--right" to="/guilder/clerkPerformance">
            <div class="icon-box">
              <i class="iconfont icon-gongzuotai-wodeyeji icon-a"></i>
              <i class="iconfont icon-gongzuotai-wodeyeji-2 icon-b"></i>
            </div>
            <div class="text">店员业绩</div>
          </router-link>
        </van-col>
        <van-col v-if="$GuilderAccess.includes('leader-wages')" span="8">
          <router-link class="item van-hairline--bottom van-hairline--right" to="/guilder/leaderWages">
            <div class="icon-box">
              <i class="iconfont icon-gongzuotai-gongzi icon-a"></i>
              <i class="iconfont icon-gongzuotai-gongzi-2 icon-b"></i>
            </div>
            <div class="text">组长工资</div>
          </router-link>
        </van-col>
        <van-col v-if="$hasFeature('clerk_category_apply') && $GuilderAccess.includes('clerk_category_examine_check')"
                 span="8">
          <router-link class="item van-hairline--bottom van-hairline--right"
                       to="/guilder/clerk-category-examine-check">
            <div class="icon-box">
              <i class="iconfont icon-gongzuotai-dianyuanjinengshenhe icon-a"></i>
              <i class="iconfont icon-gongzuotai-dianyuanjinengshenhe-2 icon-b"></i>
            </div>
            <div class="text">店员技能审核</div>
          </router-link>
        </van-col>
      </van-row>
    </van-cell-group>

    <van-cell-group v-if="hasRole('leader')" title="组长">
      <div slot="title" style="position: relative;">{{ this.$store.state.shop.id === 6 ? '店长' : '组长' }}
        <div v-if="leader != null" class="clerk-status">
          <span v-if="leader.status == 1" style="color: var(--primary-color)">在线</span>
          <span v-else-if="leader.status == 2" class="text-gray">离线</span>
          <van-switch :active-value="1" :inactive-value="2" :loading="updateLeaderStatusLoading"
                      :value="leader.status"
                      active-color="var(--primary-color)" class="margin-left-sm" inactive-color="var(--grey)"
                      size="24"
                      @input="(input)=>{updateStatus(input,'leader')}"/>
        </div>
      </div>
      <van-row class="grid">
        <van-col v-if="$LeaderAccess.includes('manual')" span="8">
          <router-link class="item van-hairline--bottom van-hairline--right" to="/article/list?type=4">
            <div class="icon-box">
              <i class="iconfont icon-gongzuotai-gongzi icon-a"></i>
              <i class="iconfont icon-gongzuotai-dianyuanshouce-2 icon-b"></i>
            </div>
            <div class="text">组长手册</div>
          </router-link>
        </van-col>
        <van-col v-if="$LeaderAccess.includes('order')" span="8">
          <router-link class="item van-hairline--bottom van-hairline--right" to="/leader/order/list">
            <div class="icon-box">
              <i class="iconfont icon-gongzuotai-waibudingdan icon-a"></i>
              <i class="iconfont icon-gongzuotai-dingdan-2 icon-b"></i>
            </div>
            <div class="text">订单</div>
          </router-link>
        </van-col>
        <van-col v-if=" $hasFeature('order_rate') && $LeaderAccess.includes('order-rate')" span="8">
          <router-link class="item van-hairline--bottom van-hairline--right" to="/leader/order/rate-list">
            <div class="icon-box">
              <i class="iconfont icon-gongzuotai-dingdanpingjia icon-a"></i>
              <i class="iconfont icon-gongzuotai-dingdanpingjia-2 icon-b"></i>
            </div>
            <div class="text">订单评价</div>
          </router-link>
        </van-col>
        <van-col v-if=" $hasFeature('order_complaint') && $LeaderAccess.includes('order-complain')" span="8">
          <router-link class="item van-hairline--bottom van-hairline--right" to="/leader/order/complain-list">
            <div class="icon-box">
              <i class="iconfont icon-gongzuotai-dingdantousu icon-a"></i>
              <i class="iconfont icon-gongzuotai-dingdantousu-2 icon-b"></i>
            </div>
            <div class="text">订单投诉</div>
          </router-link>
        </van-col>
        <van-col v-if=" $hasFeature('leader_wage_statistics') && $LeaderAccess.includes('wages')" span="8">
          <router-link class="item van-hairline--bottom van-hairline--right" to="/leader/wages">
            <div class="icon-box">
              <i class="iconfont icon-gongzuotai-gongzi icon-a"></i>
              <i class="iconfont icon-gongzuotai-gongzi-2 icon-b"></i>
            </div>
            <div class="text">工资</div>
          </router-link>
        </van-col>
        <van-col v-if="$LeaderAccess.includes('clerk-apply-list')" span="8">
          <router-link class="item van-hairline--bottom van-hairline--right" to="/leader/clerk-apply-list">
            <div class="icon-box">
              <i class="iconfont icon-gongzuotai-xindianyuanshenqing icon-a"></i>
              <i class="iconfont icon-gongzuotai-xindianyuanshenqing-2 icon-b"></i>
            </div>
            <div class="text">新店员申请</div>
          </router-link>
        </van-col>
        <van-col v-if="$LeaderAccess.includes('clerk-check-list')" span="8">
          <router-link class="item van-hairline--bottom van-hairline--right"
                       to="/leader/clerk-check/clerk-check-list">
            <div class="icon-box">
              <i class="iconfont icon-gongzuotai-dianyuanziliaoshenhe icon-a"></i>
              <i class="iconfont icon-gongzuotai-dianyuanziliaoshenhe-2 icon-b"></i>
            </div>
            <div class="text">店员资料审核</div>
          </router-link>
        </van-col>
        <van-col v-if="$hasFeature('post_list') && $LeaderAccess.includes('clerk-post-check-list')" span="8">
          <router-link class="item van-hairline--bottom van-hairline--right"
                       to="/leader/clerk-post-check-list">
            <div class="icon-box">
              <i class="iconfont icon-gongzuotai-dongtaishenhe icon-a"></i>
              <i class="iconfont icon-gongzuotai-dongtaishenhe-2 icon-b"></i>
            </div>
            <div class="text">动态审核</div>
          </router-link>
        </van-col>
        <van-col v-if="$LeaderAccess.includes('continued-apply') && $hasFeature('order_continued_apply')"
                 span="8">
          <router-link class="item van-hairline--bottom van-hairline--right" to="/leader/continued-apply">
            <div class="icon-box">
              <i class="iconfont icon-gongzuotai-xudanshenhe icon-a"></i>
              <i class="iconfont icon-gongzuotai-xudanshenhe-2 icon-b"></i>
            </div>
            <div class="text">续单审核</div>
          </router-link>
        </van-col>
        <van-col v-if="$LeaderAccess.includes('clerk-manage')" span="8">
          <router-link class="item van-hairline--bottom van-hairline--right" to="/leader/clerk-manage">
            <div class="icon-box">
              <i class="iconfont icon-gongzuotai-dianyuanguanli icon-a"></i>
              <i class="iconfont icon-gongzuotai-dianyuanguanli-2 icon-b"></i>
            </div>
            <div class="text">店员管理</div>
          </router-link>
        </van-col>
        <van-col v-if="$LeaderAccess.includes('clerk-performance')" span="8">
          <router-link class="item van-hairline--bottom van-hairline--right" to="/leader/clerk-performance">
            <div class="icon-box">
              <i class="iconfont icon-gongzuotai-wodeyeji icon-a"></i>
              <i class="iconfont icon-gongzuotai-wodeyeji-2 icon-b"></i>
            </div>
            <div class="text">店员业绩</div>
          </router-link>
        </van-col>
        <van-col v-if="$hasFeature('clerk_category_apply') && $LeaderAccess.includes('clerk_category_examine_check')"
                 span="8">
          <router-link class="item van-hairline--bottom van-hairline--right"
                       to="/leader/clerk-category-examine-check">
            <div class="icon-box">
              <i class="iconfont icon-gongzuotai-dianyuanjinengshenhe icon-a"></i>
              <i class="iconfont icon-gongzuotai-dianyuanjinengshenhe-2 icon-b"></i>
            </div>
            <div class="text">店员技能审核</div>
          </router-link>
        </van-col>
      </van-row>
    </van-cell-group>

    <van-cell-group v-if="hasRole('admin')" title="管理员">
      <van-row class="grid">
        <van-col v-if="$hasRole('super_admin') || $AdminAccess.includes('order')" span="8">
          <router-link class="item van-hairline--bottom van-hairline--right" to="/admin/order/list">
            <div class="icon-box">
              <i class="iconfont icon-gongzuotai-waibudingdan icon-a"></i>
              <i class="iconfont icon-gongzuotai-dingdan-2 icon-b"></i>
            </div>
            <div class="text">订单</div>
          </router-link>
        </van-col>
        <van-col v-if="$hasFeature('order_rate') && ($hasRole('super_admin') || $AdminAccess.includes('order-rate'))" span="8">
          <router-link class="item van-hairline--bottom van-hairline--right" to="/admin/order/rate-list">
            <div class="icon-box">
              <i class="iconfont icon-gongzuotai-dingdanpingjia icon-a"></i>
              <i class="iconfont icon-gongzuotai-dingdanpingjia-2 icon-b"></i>
            </div>
            <div class="text">订单评价</div>
          </router-link>
        </van-col>
        <van-col v-if="$hasFeature('order_complaint') && ($hasRole('super_admin') || $AdminAccess.includes('order-complain'))" span="8">
          <router-link class="item van-hairline--bottom van-hairline--right" to="/admin/order/complain-list">
            <div class="icon-box">
              <i class="iconfont icon-gongzuotai-dingdantousu icon-a"></i>
              <i class="iconfont icon-gongzuotai-dingdantousu-2 icon-b"></i>
            </div>
            <div class="text">订单投诉</div>
          </router-link>
        </van-col>
        <van-col
            v-if="$hasFeature(['clerk_group','leader_wage_statistics']) &&( $hasRole('super_admin') || $AdminAccess.includes('leader-wages'))"
            span="8">
          <router-link class="item van-hairline--bottom van-hairline--right" to="/admin/leader-wages">
            <div class="icon-box">
              <i class="iconfont icon-gongzuotai-gongzi icon-a"></i>
              <i class="iconfont icon-gongzuotai-gongzi-2 icon-b"></i>
            </div>
            <div class="text">组长工资</div>
          </router-link>
        </van-col>
        <van-col
            v-if="$hasFeature('kf_wage_statistics') && ($hasRole('super_admin') || $AdminAccess.includes('kf-wages'))"
            span="8">
          <router-link class="item van-hairline--bottom van-hairline--right" to="/admin/kf-wages">
            <div class="icon-box">
              <i class="iconfont icon-gongzuotai-gongzi icon-a"></i>
              <i class="iconfont icon-gongzuotai-gongzi-2 icon-b"></i>
            </div>
            <div class="text">客服工资</div>
          </router-link>
        </van-col>
        <van-col v-if="$hasRole('super_admin') || $AdminAccess.includes('clerk-performance')" span="8">
          <router-link class="item van-hairline--bottom van-hairline--right" to="/admin/clerk-performance">
            <div class="icon-box">
              <i class="iconfont icon-gongzuotai-wodeyeji icon-a"></i>
              <i class="iconfont icon-gongzuotai-wodeyeji-2 icon-b"></i>
            </div>
            <div class="text">店员业绩</div>
          </router-link>
        </van-col>
        <van-col v-if="$hasRole('super_admin') || $AdminAccess.includes('clerk-manage')" span="8">
          <router-link class="item van-hairline--bottom van-hairline--right" to="/admin/clerk-manage">
            <div class="icon-box">
              <i class="iconfont icon-gongzuotai-dianyuanguanli icon-a"></i>
              <i class="iconfont icon-gongzuotai-dianyuanguanli-2 icon-b"></i>
            </div>
            <div class="text">店员管理</div>
          </router-link>
        </van-col>
        <van-col
            v-if="$hasFeature('post_list') && ( $hasRole('super_admin') || $AdminAccess.includes('post-list'))"
            span="8">
          <router-link class="item van-hairline--bottom van-hairline--right" to="/admin/post-list">
            <div class="icon-box">
              <i class="iconfont icon-gongzuotai-dongtaiguanli icon-a"></i>
              <i class="iconfont icon-gongzuotai-dongtaiguanli-2 icon-b"></i>
            </div>
            <div class="text">动态管理</div>
          </router-link>
        </van-col>
        <van-col v-if="$hasRole('super_admin') || $AdminAccess.includes('check-list')" span="8">
          <router-link class="item van-hairline--bottom van-hairline--right" to="/admin/check-list">
            <div class="icon-box">
              <i class="iconfont icon-gongzuotai-dianyuanziliaoshenhe icon-a"></i>
              <i class="iconfont icon-gongzuotai-dianyuanziliaoshenhe-2 icon-b"></i>
            </div>
            <div class="text">店员资料审核</div>
          </router-link>
        </van-col>
        <van-col
            v-if=" ($hasRole('super_admin') || $AdminAccess.includes('continued-apply')) && $hasFeature('order_continued_apply')"
            span="8">
          <router-link class="item van-hairline--bottom van-hairline--right"
                       to="/admin/order/continued-apply">
            <div class="icon-box">
              <i class="iconfont icon-gongzuotai-xudanshenhe icon-a"></i>
              <i class="iconfont icon-gongzuotai-xudanshenhe-2 icon-b"></i>
            </div>
            <div class="text">续单审核</div>
          </router-link>
        </van-col>

        <van-col v-if="$store.state.shop.platform == $store.state.ShopPlatformEnum.DINGTALK.value" span="8">
          <router-link class="item van-hairline--bottom van-hairline--right" to="/leader/get_userid">
            <div class="icon-box">
              <i class="iconfont icon-gongzuotai-wodeziliao icon-a"></i>
              <i class="iconfont icon-gongzuotai-wodeziliao-2 icon-b"></i>
            </div>
            <div class="text">获取用户ID</div>
          </router-link>
        </van-col>
        <van-col v-if="$AdminAccess.includes('clerk-apply')" span="8">
          <router-link class="item van-hairline--bottom van-hairline--right" to="/admin/clerk-apply-list">
            <div class="icon-box">
              <i class="iconfont icon-gongzuotai-xindianyuanshenqing icon-a"></i>
              <i class="iconfont icon-gongzuotai-xindianyuanshenqing-2 icon-b"></i>
            </div>
            <div class="text">新店员申请</div>
          </router-link>
        </van-col>
        <van-col v-if="$hasRole('super_admin') || $AdminAccess.includes('user-manage')" span="8">
          <router-link class="item van-hairline--bottom van-hairline--right" to="/admin/user/user-list">
            <div class="icon-box">
              <i class="iconfont icon-gongzuotai-yonghuguanli icon-a"></i>
              <i class="iconfont icon-gongzuotai-yonghuguanli-2 icon-b"></i>
            </div>
            <div class="text">用户管理</div>
          </router-link>
        </van-col>
        <van-col v-if="$hasFeature('tech_support_visitor') && $hasRole('super_admin')" span="8">
          <router-link class="item van-hairline--bottom van-hairline--right" to="/admin/tech-support-visitor-list">
            <div class="icon-box">
              <i class="iconfont icon-gongzuotai-qiangdandating icon-a"></i>
              <i class="iconfont icon-gongzuotai-qiangdandating-2 icon-b"></i>
            </div>
            <div class="text">开店咨询</div>
          </router-link>
        </van-col>
        <van-col v-if="$hasFeature('clerk_category_apply') && $AdminAccess.includes('clerk_category_examine_check')"
                 span="8">
          <router-link class="item van-hairline--bottom van-hairline--right" to="/admin/clerk-category-examine-check">
            <div class="icon-box">
              <i class="iconfont icon-gongzuotai-dianyuanjinengshenhe icon-a"></i>
              <i class="iconfont icon-gongzuotai-dianyuanjinengshenhe-2 icon-b"></i>
            </div>
            <div class="text">店员技能审核</div>
          </router-link>
        </van-col>
        <van-col
            v-if="$hasFeature('group_purchase') && ($hasRole('super_admin') || $AdminAccess.includes('purchase_order'))"
            span="8">
          <router-link class="item van-hairline--bottom van-hairline--right" to="/admin/purchase-order/list">
            <div class="icon-box">
              <i class="iconfont icon-gongzuotai-waibudingdan icon-a"></i>
              <i class="iconfont icon-gongzuotai-dingdan-2 icon-b"></i>
            </div>
            <div class="text">团购订单</div>
          </router-link>
        </van-col>
        <van-col
            v-if="$hasFeature('group_purchase') && ($hasRole('super_admin') || $AdminAccess.includes('purchase_order_rate'))"
            span="8">
          <router-link class="item van-hairline--bottom van-hairline--right" to="/admin/purchase-order/rate-list">
            <div class="icon-box">
              <i class="iconfont icon-gongzuotai-dingdanpingjia icon-a"></i>
              <i class="iconfont icon-gongzuotai-dingdanpingjia-2 icon-b"></i>
            </div>
            <div class="text">团购评价</div>
          </router-link>
        </van-col>
        <van-col span="8" v-if="$hasRole('super_admin') || $hasRole('admin')">
          <router-link class="item van-hairline--bottom van-hairline--right" to="/admin/notice/log-message">
            <div class="icon-box">
              <i class="iconfont icon-gongzuotai-gonggaoliebiao icon-a"></i>
              <i class="iconfont icon-gongzuotai-gonggaoliebiao-2 icon-b"></i>
            </div>
            <div class="text">消息中心</div>
          </router-link>
        </van-col>
        <van-col
            v-if="($store.state.shop.id == 1 || $store.state.shop.id == 1808) && ($hasRole('super_admin') || $hasRole('admin')) && $AdminAccess.includes('distributor-pay-order')"
            span="8">
          <router-link class="item van-hairline--bottom van-hairline--right" to="/admin/distributor-pay-order/list">
            <div class="icon-box">
              <i class="iconfont icon-gongzuotai-waibudingdan icon-a"></i>
              <i class="iconfont icon-gongzuotai-dingdan-2 icon-b"></i>
            </div>
            <div class="text">分销入驻订单</div>
          </router-link>
        </van-col>
      </van-row>
    </van-cell-group>

    <div class="text-center padding-tb">
      <router-link to="/clear-storage">清理缓存</router-link>
    </div>

    <foot v-if="$store.state.shop.id != 11 && $store.state.shop.id != 13 && $store.state.shop.id != 34 && $store.state.shop.id != 75
        && $store.state.shop.id != 127 && $store.state.shop.id != 6 && $store.state.shop.id != 1508 && $store.state.shop.id != 16 && $store.state.shop.id != 125 && $store.state.shop.id != 190"></foot>

    <template v-if="$store.state.shop.id == 127">
      <div>
        <div class="text-center padding-tb-lg">
          <div style="color: #ccc" @click="showOpenShop=true">我要开店</div>
        </div>
      </div>

      <van-dialog v-model="showOpenShop">
        <div class="flex justify-center">
          <img alt="qrcode" src="/static/images/127/qrcode.png" style="width: 300px;">
        </div>
      </van-dialog>
    </template>

  </div>
</template>

<script>
import Vue from 'vue';

import {Cell, CellGroup, Col, Dialog, Icon, Row, Switch, Toast, NoticeBar} from 'vant';
import {
  getClerk,
  getItemSwitchList,
  updateClerkAutoOnlineStatus,
  updateClerkStatus,
  updateItemSwitch,
  updateRandomOrderSwitch,
  updateRecommendOn
} from '@/api/clerk/clerk'
import foot from '@/views/foot';
import {getKf, updateKfStatus} from "@/api/kf/kf";
import {getLeader, updateLeaderStatus} from "@/api/leader/leader";
import {getClerkSetting} from "@/api/shop";
import QuestionMark from "@/views/question-mark";
import announcement from "@/views/announcement";
import balanceWithdraw from "@/components/common/balance-withdraw";

Vue.use(Row)
    .use(Col)
    .use(Icon)
    .use(CellGroup)
    .use(Cell)
    .use(Switch)
    .use(Dialog)
    .use(Toast)
    .use(NoticeBar)

export default {
  name: 'index',
  components: {
    announcement,
    QuestionMark,
    balanceWithdraw,
    foot
  },
  data() {
    return {
      showOpenShop: false,
      roles: null,
      clerkIsAutoOnline: false,
      clerk: {},
      dispatchOrderPermission: [],
      kf: null,
      leader: null,
      updateClerkRecommendOnLoading: false,
      updateClerkStatusLoading: false,
      updateKfStatusLoading: false,
      updateLeaderStatusLoading: false,
      itemSwitchList: [],
      clerkItemSwitchIds: [],
      allowRandomOrderSwitch: null,
      specifySwitch: [],
      randomSwitch: [],
      specifyShow: true,
      randomShow: false,
      clerkJoinCategoryApply: false,
    }
  },
  methods: {
    hasRole(role) {
      if (this.roles == null) {
        return false;
      }
      return this.roles.indexOf(role) != -1;
    },
    loadData() {
      this.roles = this.$store.state.roles
      if (this.hasRole('clerk')) {
        this.loadClerkInfo()
      }
      if (this.hasRole('kf')) {
        this.loadKfInfo()
      }
      if (this.hasRole('leader')) {
        this.loadLeaderInfo()
      }
    },
    loadClerkInfo() {
      Promise.all([getClerk(), getItemSwitchList(), getClerkSetting()]).then((results) => {

        const data1 = results[0].data
        const data2 = results[1].data
        const data3 = results[2].data
        if (data1.code != 0) {
          Dialog.alert({
            title: '加载' + this.$store.state.label.clerkLabel + '信息失败',
            desc: data1.msg
          })
        }
        if (data2.code != 0) {
          Dialog.alert({
            title: '加载服务失败',
            message: data2.msg
          })
        }
        if (data3.code != 0) {
          Dialog.alert({
            title: '加载店铺设置失败',
            message: data3.msg
          })
        }

        this.clerk = data1.clerk
        this.clerkJoinCategoryApply = data1.clerkJoinCategoryApply
        this.clerkIsAutoOnline = this.clerk.isAutoOnline
        this.specifySwitch = data2.fixedList
        this.randomSwitch = data2.randomList
        this.dispatchOrderPermission = data1.dispatchOrderPermission || []
        this.itemSwitchList = data2.itemSwitchList
        // data2.itemSwitchList.forEach((item) => {
        //     if (item.type == 1) {
        //         this.specifySwitch.push(item)
        //     } else if (item.type == 2) {
        //         this.randomSwitch.push(item)
        //     }
        // })
        this.clerkItemSwitchIds = data2.clerkItemSwitchIds
        this.allowRandomOrderSwitch = data3.setting.allowRandomOrderSwitch
      }).catch((e) => {
        Dialog.alert({
          title: '加载数据失败',
          message: JSON.stringify(e)
        })
      })
    },
    loadKfInfo() {
      getKf().then(res => {
        const data = res.data;
        if (data.code != 0) {
          Dialog.alert({
            title: '加载客服信息失败',
            desc: data.msg
          })
        }
        this.kf = data.kf
      })
    },
    loadLeaderInfo() {
      getLeader().then(res => {
        const data = res.data;
        if (data.code !== 0) {
          Dialog.alert({
            title: '加载组长信息失败',
            desc: data.msg
          })
        }
        this.leader = data.leader
      })
    },
    updateClerkIsAutoOnline() {
      updateClerkAutoOnlineStatus(this.clerkIsAutoOnline).then(res => {
        const data = res.data;
        if (data.code == 0) {
          Toast("修改成功")
        } else {
          this.clerkIsAutoOnline = false
          Dialog.alert({
            title: '修改失败',
            message: data.msg
          })
        }
      })
    },
    updateStatus(status, role) {
      let updateAutoOnline = false;
      switch (role) {
        case 'clerk':
          this.updateClerkStatusLoading = true
          if (this.$hasFeature('auto_online')) {
            updateAutoOnline = true;
          }
          updateClerkStatus(status, updateAutoOnline).then(res => {
            this.updateClerkStatusLoading = false
            const data = res.data;
            if (data.code == 0) {
              Toast('修改状态成功')
              this.loadClerkInfo()
            } else {
              // this.loadData()
              Dialog.alert({
                title: '修改状态失败',
                message: data.msg
              })
            }
            // this.loadData()
          });
          break;
        case 'kf':
          this.updateKfStatusLoading = true;
          updateKfStatus(status).then(res => {
            this.updateKfStatusLoading = false
            const data = res.data;
            if (data.code == 0) {
              this.kf.status = status
              Toast('修改状态成功')
            } else {
              this.loadData()
              Dialog.alert({
                title: '修改状态失败',
                message: data.msg
              })
            }
          });
          break;
        case 'leader':
          this.updateLeaderStatusLoading = true;
          updateLeaderStatus(status).then(res => {
            this.updateLeaderStatusLoading = false
            const data = res.data;
            if (data.code == 0) {
              this.leader.status = status
              Toast('修改状态成功')
            } else {
              this.loadData()
              Dialog.alert({
                title: '修改状态失败',
                message: data.msg
              })
            }
          });
          break;
      }

    },
    updateRecommendOn(recommendOn) {
      this.updateClerkRecommendOnLoading = true
      updateRecommendOn(recommendOn).then(res => {
        this.updateClerkRecommendOnLoading = false
        const data = res.data;
        if (data.code == 0) {
          Toast('修改成功')
          this.loadData()
        } else {
          Dialog.alert({
            title: '修改失败',
            message: data.msg
          }).then(() => {
            // this.loadData()
          })
        }
      })
    },
    updateRandomOrderSwitch(randomOrderSwitch) {
      updateRandomOrderSwitch(randomOrderSwitch).then(res => {
        const data = res.data;
        if (data.code == 0) {
          Toast('修改成功')
          this.loadData()
        } else {
          Dialog.alert({
            title: '修改失败',
            message: data.msg
          }).then(() => {
            // this.loadData()
          })
        }
      })
    },
    updateItemSwitch(switchId) {
      let switchIds = [].concat(this.clerkItemSwitchIds)
      if (switchIds.indexOf(switchId) != -1) {
        switchIds.splice(switchIds.indexOf(switchId), 1)
      } else {
        switchIds.push(switchId)
      }

      Toast.loading({
        mask: true,
        message: '请稍候'
      })
      updateItemSwitch(
          JSON.stringify(switchIds),
          switchId
      ).then(res => {
        Toast.clear()
        const data = res.data;
        if (data.code == 0) {
          this.clerkItemSwitchIds = switchIds
          Toast('修改成功')
        } else {
          // this.loadData()
          Dialog.alert({
            title: '修改失败',
            message: data.msg
          })
        }
      })
    }
  },
  activated() {
    this.loadData()
  },

  // mounted() {
  //   this.loadData()
  // }
}
</script>

<style lang="less" scoped>

.van-cell-group {
  background: none;
}

.grid {
  .item {
    display: block;
    padding: 20px 0;
    text-align: center;
    background: #FFFFFF;

    .icon-box{
      position: relative;
      display: inline-block;
      .icon-a{
        font-size: 25px;
        line-height: 25px;
        color: #323232;
      }
      .icon-b{
        font-size: 25px;
        line-height: 25px;
        position: absolute;
        left: 0;
        right: 0;
        color: var(--primary-color);
      }
    }

    &:active {
      background: #e5e5e5;
    }

    .icon {

    }

    .text {
      color: #333;
      font-size: 14px;
      margin-top: 8px;
    }
  }
}

.clerk-status {
  position: absolute;
  right: 0;
  bottom: -5px;
  display: flex;
  align-items: center;
}

.item-switch {
  padding: 15px 0;

  .switch-wrap {
    text-align: center;
  }

  .item-name {
    font-size: 10px;
  }
}

.specifyTitle,
.randomTitle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 30px;

  .down {
    width: 25px;
    transition-duration: 500ms;
  }
}


.specifyFold,
.randomFold {
  overflow: hidden;
  transition-duration: 300ms;
  flex-wrap: wrap;
  overflow-y: auto;
  padding-top: 8px;

  &::-webkit-scrollbar {
    width: 0 !important
  }

  .switchItem {
    width: 25%;
    display: inline-flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 10px;
    font-size: 10px;

    .item-name {
      margin-top: 3px;
    }
  }
}

.switch-title {
  background: #FFFFFF;
  padding: 10px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .title {
    font-size: 14px;
    font-weight: 500;
    color: #333;
  }

  .title-right {
    display: flex;
    align-items: center;

    span {
      font-size: 10px;
      color: #B3B3B3;
      font-weight: 500;
    }

    img {
      width: 22px;
      height: 22px;
      display: block;
    }
  }
}

.switch-body {
  background: #FAFAFA;
  padding: 20px 20px 5px 20px;
  width: calc(100% - 20px * 2);

  .title {
    font-size: 12px;
    color: #666666;
    font-weight: 500;
    margin-bottom: 15px;
  }

  .switch-box {
    width: 100%;
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    .switch {
      width: 33.33%;
      display: flex;
      align-items: center;
      margin-bottom: 15px;

      .switch-name {
        color: #666666;
        font-size: 12px;
        font-weight: 500;
        margin-left: 6px;
        flex: 1;
      }
    }
  }
}
</style>
